import React, { useState } from 'react';
import { Icon } from 'semantic-ui-react';
import * as Styles from './CreditCard.style';
import classes from 'assets/css/fading-animation.module.css';
import { useTranslation, Trans } from 'react-i18next';
import { Highlight } from 'components/vm-deployment/components';
import PaymentMethod from 'components/common/payment-method';
import { Formik } from 'formik';
import { initialValues, NewCreditCardError } from '../constants';
import { validationObject } from 'validations';
import PaymentForm from 'components/Payment-form';
import StoredCard from '../stored-cards';
import { Notification } from 'components/vm-deployment/components';
import creditCardClasses from './CreditCard.module.css';
import { Message } from 'components/alert/Message';
import { scrollToSection } from 'utils';
import CustomButton from 'components/common/custom-button';
import ConditionalFragment from 'components/conditional-fragment';
import { Heading } from 'components/user-management/Heading';
import { mockUserUiDetails } from 'pages/mockup/constant';

const CreditCard = ({ rights, storedCreditCards }) => {
  const { t } = useTranslation();
  const [clickedItem, setClickedItem] = useState({});

  const defaultCardAvailaible = (storedCreditCards?.billing_stored_credit_cards || []).some(
    (item) => item?.default === '1',
  );

  const handleCreateCreditCard = async () => {};

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationObject}
      onSubmit={(values, { resetForm }) => handleCreateCreditCard(values, resetForm)}
    >
      {(formikProp) => (
        <Styles.CreditCardSC background={mockUserUiDetails.show_funds_deposit_section != 0}>
          <Styles.CreditCards id="credit_cards">
            <Heading>
              <Trans i18nKey="account/billing_info.string30" components={{ highlight: <Highlight /> }} />
            </Heading>
            <Styles.Paragraph>
              <p>{t('account/billing_info.string31')}</p>
            </Styles.Paragraph>
            {(storedCreditCards?.billing_stored_credit_cards || []).map((item) => (
              <StoredCard
                key={item?.id}
                data={item}
                rights={rights}
                itemsDeleted={[]}
                clickedItem={clickedItem || {}}
                updateCreditCardLoading={false}
                deleteCreditCardLoading={false}
                onDoNotDefaultClick={() => {
                  setClickedItem({ id: item.id, do_not_default: true });
                }}
                onDefaultClick={() => {
                  setClickedItem({ id: item.id, default: true });
                }}
                onDeleteClick={() => {
                  setClickedItem({ id: item.id, delete: true });
                }}
              />
            ))}
            <ConditionalFragment
              condition={storedCreditCards?.billing_stored_credit_cards.length && !defaultCardAvailaible}
            >
              <div className={!defaultCardAvailaible ? classes.price_box_show : classes.price_box_hide}>
                <Styles.NotificationContainer>
                  <Notification bg={'true'}>
                    <Icon name="info circle" />
                    {t('alert10')}
                  </Notification>
                </Styles.NotificationContainer>
              </div>
            </ConditionalFragment>
            <ConditionalFragment condition={rights.billingaddcc !== 0}>
              <Styles.NewCard
                storedCards={storedCreditCards?.billing_stored_credit_cards?.length}
                id="new_card"
                className={defaultCardAvailaible && creditCardClasses.newCardClose}
              >
                <PaymentMethod
                  heading={t('account/billing_info.string32')}
                  data={{ id: 'new_card' }}
                  setCheckedValue={(e) =>
                    formikProp.setFieldValue('new_card', formikProp.values?.new_card == 'new_card' ? '' : e)
                  }
                  checkboxValue={formikProp.values?.new_card || ''}
                  onClick={() => {
                    formikProp.setFieldValue('new_card', formikProp.values?.new_card == 'new_card' ? '' : 'new_card');
                  }}
                  style={
                    formikProp.errors['new_card'] && formikProp.touched['new_card']
                      ? {
                          color: 'white',
                          background: '#d80000',
                        }
                      : {}
                  }
                />
              </Styles.NewCard>
              <Styles.NewCardForm>
                {formikProp.values?.new_card && (
                  <>
                    <PaymentForm addFunds={'true'} formikProp={formikProp} />
                    <CustomButton
                      isLoading={false}
                      onClick={async () => {
                        const errors = await formikProp?.validateForm();
                        formikProp?.handleSubmit();
                        if (NewCreditCardError(errors)) {
                          Message.error(t('string14'), t('string13'));
                          return scrollToSection('new_card');
                        }
                      }}
                      title={t('account/billing_info.string32')}
                      buttonStyles={{
                        marginTop: '2rem',
                        opacity: !formikProp.isValid && 0.3,
                        backgroundColor: !formikProp.isValid && 'gray',
                      }}
                    />
                  </>
                )}
              </Styles.NewCardForm>
            </ConditionalFragment>
          </Styles.CreditCards>
        </Styles.CreditCardSC>
      )}
    </Formik>
  );
};
export default CreditCard;
